
export const BingPrivacyMessage: React.FC = () => {
    return (
        <div className="flex flex-wrap mb-2">
            <div className="w-full rounded-md p-1 mb-1">
                <div className="flex items-center">
                    <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <div className="ml-3">
                        <p className="text-xs text-slate-500 dark:text-slate-400">
                            The Bing <a href="https://www.microsoft.com/en-us/privacy/privacystatement" target="_blank" className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline">Privacy Policy</a> applies to this conversation. Please ensure you don't provide company confidential information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}